import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=36555a21&"
import script from "./GenericError.vue?vue&type=script&lang=js&"
export * from "./GenericError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36555a21')) {
      api.createRecord('36555a21', component.options)
    } else {
      api.reload('36555a21', component.options)
    }
    module.hot.accept("./GenericError.vue?vue&type=template&id=36555a21&", function () {
      api.rerender('36555a21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GenericError.vue"
export default component.exports